var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"price"},[_c('div',{staticClass:"price-text",style:(_vm.styleCss)},[_vm._v(_vm._s(_vm.priceToFixedTwo))]),_c('div',{staticClass:"token",style:(`width:${_vm.width}rem;height:${_vm.width}rem;`)},[_c('img',{attrs:{"src":require("@/assets/mybox/home/musd52x52-max.png")}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }